<h2>User Management</h2>

<div class="px-2 py-3 contents h-full max-h-80">
    <dx-data-grid 
        #userManagmentGrid
        id="userManagmentGrid" 
        [allowColumnResizing]="true" 
                [columnResizingMode]="'widget'" 
        [dataSource]="dataSource" 
        [showBorders]="true"
        [columnAutoWidth]="true"
        [remoteOperations]="true"
        [hoverStateEnabled]="true"
        [allowColumnReordering]="true">

        <dxo-filter-row [visible]="true"></dxo-filter-row>
        <!-- <dxo-header-filter [visible]="true"></dxo-header-filter> -->
        <dxo-selection mode="single"></dxo-selection>

        <dxi-column dataField="UserId" caption="User Id" [customizeText]="customizeUserId"></dxi-column>
        <dxi-column caption="Action" cellTemplate="action" alignment="left"></dxi-column>
        <dxi-column dataField="PrincipalName" [allowEditing]="false"></dxi-column>
        <dxi-column dataField="UserRoleName" caption="User Role" [allowEditing]="false"></dxi-column>
        <dxi-column dataField="LastKnownSurname" caption="Last Name" [allowEditing]="false"></dxi-column>
        <dxi-column dataField="LastKnownMiddleName" caption="Middle Name" [allowEditing]="false"></dxi-column>
        <dxi-column dataField="LastKnownGivenName" caption="First Name" [allowEditing]="false"></dxi-column>
        <dxi-column dataField="LastKnownEmailAddress" caption="E-mail Address"></dxi-column>
        <dxi-column dataField="LastKnownFullNameSortableOrPrincipalName" caption="Display Name" [allowEditing]="false"></dxi-column>
        <dxi-column dataField="Active" caption="Is Active"></dxi-column>
        <dxi-column dataField="CreatedOn" caption="Created on" dataType="date"></dxi-column>

        <div *dxTemplate="let action of 'action'">
            <dx-button
                id="btnPromote"
                *ngIf="currentUser.UserRoleId == 3 && action?.data?.UserRoleId > 0 && action?.data?.UserRoleId < 3 && currentUser.UserId !== action?.data?.UserId && action?.data?.Active"
                class="mr-1"
                icon="fa fa-level-up-alt fa-1x"
                hint="Promote"
                (onClick)="promote()"
            ></dx-button>
            <dx-button
                id="btnDemote"
                *ngIf="currentUser.UserRoleId == 3 && action?.data?.UserRoleId > 1 && currentUser.UserId !== action?.data?.UserId && action?.data?.Active"
                icon="fas fa-level-down-alt fa-1x"
                hint="Demote"
                (onClick)="demote()"
            ></dx-button>
            <dx-button *ngIf="currentUser.UserRoleId > 1 && action?.data?.UserRoleId > 0 && currentUser.UserId !== action?.data?.UserId && action?.data?.Active" icon="fas fa-trash-alt fa-1x" hint="Deactivate" (onClick)="deactivate()"></dx-button>
            <dx-button *ngIf="currentUser.UserRoleId > 1 && action?.data?.UserRoleId > 0 && currentUser.UserId !== action?.data?.UserId && !action?.data?.Active" icon="fas fa-trash-alt fa-1x" hint="Reactivate" (onClick)="reactivate()"></dx-button>
        </div>
    </dx-data-grid>
</div>